import ZoomAppsSdk from './ZoomSdk';

export type applyProxyFunction =
  | ZoomAppsSdk['addEventListener']
  | ZoomAppsSdk['callZoomApi'];

function createApplyProxy(targetApi: applyProxyFunction, prop: string) {
  return new Proxy(targetApi, {
    apply: (addEventListenerTarget, thisArg, argumentsList) => {
      // attempt to call addEventListener
      return Reflect.apply(addEventListenerTarget, thisArg, [
        prop,
        ...argumentsList,
      ]);
    },
  });
}

// from: https://javascript.plainenglish.io/javascript-how-to-intercept-function-and-method-calls-b9fd6507ff02
function interceptUndefinedMethod(sdk: ZoomAppsSdk): ZoomAppsSdk {
  return new Proxy(sdk, {
    get(sdkTarget, prop) {
      const safeProp = String(prop);

      if (
        // if the method is not a _somethingAccessor
        safeProp.charAt(0) !== '_' &&
        // if the property is not default
        safeProp !== 'default' &&
        // or if the method does not exist on the sdk
        !(sdkTarget as any)[safeProp]
      ) {
        console.warn(
          `Method ${safeProp} is not available in this version of Zoom Apps SDK and might not work correctly. Please, update your version of Zoom Apps SDK`
        );
        // if the method is an event (specifically matches the string "on" at the start of the safeProp name)
        if (String(safeProp).match(/^on/gm)) {
          return createApplyProxy(sdk.addEventListener, safeProp);
        } else {
          // otherwise route it to callZoomApi
          return createApplyProxy(sdk.callZoomApi, safeProp);
        }
      } else {
        return Reflect.get(sdkTarget, safeProp);
      }
    },
  });
}

export default interceptUndefinedMethod;
